// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../Assets/images/Intervenants-bg-matching-plat.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../Assets/images/accueil-abonnements-matching-plat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../Assets/images/accueil-jetons-matching-plat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../Assets/images/matching-plt-header-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileIntervenant_speciality-span__G-E2A {
    display: inline-block; /* Ensures spans behave like boxes */
    border: 2px solid #4AAE9B;
    border-radius: 30px;
    color: #4AAE9B;
    padding: 10px 20px;
    margin: 10px; /* Uniform spacing on all sides */
    text-align: center; /* Centers text within the span */
    font-size: 14px; /* Base font size */
    word-break: break-word; /* Prevent overflow */
}
@media (max-width: 599px) {
    .ProfileIntervenant_description__R6wrq{
        padding-left: 0px;
    }
}
@media (min-width: 600px) {
    .ProfileIntervenant_description__R6wrq{
        padding-left: 50px;
    }
}
.ProfileIntervenant_div-speciality__IBJ-N {
    display: flex; /* Use flexbox for layout */
    flex-wrap: wrap; /* Allow spans to wrap to the next line */
    gap: 10px; /* Adjust spacing between items */
    margin-top: 30px;
}
.ProfileIntervenant_bg-section-boutique__oWN3S{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: top;
    padding: 5%;
    background-size: cover;
}
section{
    background-color: white;
}
.ProfileIntervenant_section-reservation__QMC-i{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: top;
    text-align: center;
    /* padding: 6% 10%; */
}
@media (max-width: 690px) {
    .ProfileIntervenant_section-reservation__QMC-i{
        padding: 15% 10%;
    }
    .ProfileIntervenant_bg-section-boutique__oWN3S{
    padding: 15% 5%;
}
}
@media (min-width: 691px) {
    .ProfileIntervenant_section-reservation__QMC-i{
        padding: 6% 10%;
    }
     .ProfileIntervenant_bg-section-boutique__oWN3S{
    padding: 6% 5%;
}
}

@media (max-width: 690px) {
    .ProfileIntervenant_section-consultation__-Qbvp{
        padding: 0px 10% 15% 10%;
    }
}
@media (min-width: 691px) {
    .ProfileIntervenant_section-consultation__-Qbvp{
        padding: 0px 10% 3% 10%;
    }
}

.ProfileIntervenant_section-videos__jQ3Sz{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: bottom;
}
.ProfileIntervenant_section-description__eYQBW{
    padding: 10% 10% 50px 10%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-size: cover;
}
@media (max-width: 768px) {
    .ProfileIntervenant_typo-responsive__NWQqG {
      font-size: 1.5rem; 
    }
    .ProfileIntervenant_speciality-span__G-E2A {
        padding: 8px 16px; /* Adjust padding for smaller screens */
        font-size: 12px; /* Smaller font size */
    }

    .ProfileIntervenant_div-speciality__IBJ-N {
        justify-content: flex-start; /* Align spans to the left on small screens */
    }
     
  }
  @media (max-width: 480px) {
    .ProfileIntervenant_speciality-span__G-E2A {
        font-size: 10px; /* Further reduce font size */
        padding: 6px 12px; /* Compact padding */
        margin: 5px; /* Reduce margin */
    }
    
}

.ProfileIntervenant_arrowDown__skPSW{
    animation: ProfileIntervenant_MoveUpDown__IAAjc 1s linear infinite;
     position: relative;
     left: 0;
     bottom: 0;
   }
  
   @media (max-width: 1089px) {
    .ProfileIntervenant_arrowDown__skPSW{
      width: 5% !important;
    }
  }

  .ProfileIntervenant_center__\\+2Oc3 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 35px;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/IntervenantsPage/Intervenants/ProfileIntervenant/ProfileIntervenant.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB,EAAE,oCAAoC;IAC3D,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAAY,EAAE,iCAAiC;IAC/C,kBAAkB,EAAE,iCAAiC;IACrD,eAAe,EAAE,mBAAmB;IACpC,sBAAsB,EAAE,qBAAqB;AACjD;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,aAAa,EAAE,2BAA2B;IAC1C,eAAe,EAAE,yCAAyC;IAC1D,SAAS,EAAE,iCAAiC;IAC5C,gBAAgB;AACpB;AACA;IACI,yDAAkF;IAClF,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yDAAsF;IACtF,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI;QACI,gBAAgB;IACpB;IACA;IACA,eAAe;AACnB;AACA;AACA;IACI;QACI,eAAe;IACnB;KACC;IACD,cAAc;AAClB;AACA;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,yDAAiF;IACjF,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,yDAA2E;IAC3E,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI;MACE,iBAAiB;IACnB;IACA;QACI,iBAAiB,EAAE,uCAAuC;QAC1D,eAAe,EAAE,sBAAsB;IAC3C;;IAEA;QACI,2BAA2B,EAAE,6CAA6C;IAC9E;;EAEF;EACA;IACE;QACI,eAAe,EAAE,6BAA6B;QAC9C,iBAAiB,EAAE,oBAAoB;QACvC,WAAW,EAAE,kBAAkB;IACnC;;AAEJ;;AAEA;IACI,kEAAwC;KACvC,kBAAkB;KAClB,OAAO;KACP,SAAS;GACX;;GAEA;IACC;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB","sourcesContent":[".speciality-span {\n    display: inline-block; /* Ensures spans behave like boxes */\n    border: 2px solid #4AAE9B;\n    border-radius: 30px;\n    color: #4AAE9B;\n    padding: 10px 20px;\n    margin: 10px; /* Uniform spacing on all sides */\n    text-align: center; /* Centers text within the span */\n    font-size: 14px; /* Base font size */\n    word-break: break-word; /* Prevent overflow */\n}\n@media (max-width: 599px) {\n    .description{\n        padding-left: 0px;\n    }\n}\n@media (min-width: 600px) {\n    .description{\n        padding-left: 50px;\n    }\n}\n.div-speciality {\n    display: flex; /* Use flexbox for layout */\n    flex-wrap: wrap; /* Allow spans to wrap to the next line */\n    gap: 10px; /* Adjust spacing between items */\n    margin-top: 30px;\n}\n.bg-section-boutique{\n    background-image: url(../../../../Assets/images/Intervenants-bg-matching-plat.jpg);\n    background-repeat: no-repeat;\n    background-position: top;\n    padding: 5%;\n    background-size: cover;\n}\nsection{\n    background-color: white;\n}\n.section-reservation{\n    background-image: url(../../../../Assets/images/accueil-abonnements-matching-plat.png);\n    background-repeat: no-repeat;\n    background-position: top;\n    text-align: center;\n    /* padding: 6% 10%; */\n}\n@media (max-width: 690px) {\n    .section-reservation{\n        padding: 15% 10%;\n    }\n    .bg-section-boutique{\n    padding: 15% 5%;\n}\n}\n@media (min-width: 691px) {\n    .section-reservation{\n        padding: 6% 10%;\n    }\n     .bg-section-boutique{\n    padding: 6% 5%;\n}\n}\n\n@media (max-width: 690px) {\n    .section-consultation{\n        padding: 0px 10% 15% 10%;\n    }\n}\n@media (min-width: 691px) {\n    .section-consultation{\n        padding: 0px 10% 3% 10%;\n    }\n}\n\n.section-videos{\n    background-image: url(../../../../Assets/images/accueil-jetons-matching-plat.png);\n    background-repeat: no-repeat;\n    background-position: bottom;\n}\n.section-description{\n    padding: 10% 10% 50px 10%;\n    background-image: url(../../../../Assets/images/matching-plt-header-bg.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n@media (max-width: 768px) {\n    .typo-responsive {\n      font-size: 1.5rem; \n    }\n    .speciality-span {\n        padding: 8px 16px; /* Adjust padding for smaller screens */\n        font-size: 12px; /* Smaller font size */\n    }\n\n    .div-speciality {\n        justify-content: flex-start; /* Align spans to the left on small screens */\n    }\n     \n  }\n  @media (max-width: 480px) {\n    .speciality-span {\n        font-size: 10px; /* Further reduce font size */\n        padding: 6px 12px; /* Compact padding */\n        margin: 5px; /* Reduce margin */\n    }\n    \n}\n\n.arrowDown{\n    animation: MoveUpDown 1s linear infinite;\n     position: relative;\n     left: 0;\n     bottom: 0;\n   }\n  \n   @media (max-width: 1089px) {\n    .arrowDown{\n      width: 5% !important;\n    }\n  }\n\n  .center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 35px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"speciality-span": `ProfileIntervenant_speciality-span__G-E2A`,
	"description": `ProfileIntervenant_description__R6wrq`,
	"div-speciality": `ProfileIntervenant_div-speciality__IBJ-N`,
	"bg-section-boutique": `ProfileIntervenant_bg-section-boutique__oWN3S`,
	"section-reservation": `ProfileIntervenant_section-reservation__QMC-i`,
	"section-consultation": `ProfileIntervenant_section-consultation__-Qbvp`,
	"section-videos": `ProfileIntervenant_section-videos__jQ3Sz`,
	"section-description": `ProfileIntervenant_section-description__eYQBW`,
	"typo-responsive": `ProfileIntervenant_typo-responsive__NWQqG`,
	"arrowDown": `ProfileIntervenant_arrowDown__skPSW`,
	"MoveUpDown": `ProfileIntervenant_MoveUpDown__IAAjc`,
	"center": `ProfileIntervenant_center__+2Oc3`
};
export default ___CSS_LOADER_EXPORT___;
